import { render } from "./IconPairing.vue?vue&type=template&id=ffa55e62"
import script from "./IconPairing.vue?vue&type=script&lang=ts"
export * from "./IconPairing.vue?vue&type=script&lang=ts"
script.render = render

export default script